module.exports = __webpack_public_path__ + "glass.11433e1493edbba9fe71.jpg";


//////////////////
// WEBPACK FOOTER
// D:/TELEMED-FINAL/telemed/src/assets/img/glass.jpg
// module id = ../../../../../src/assets/img/glass.jpg
// module chunks = styles